export const SNAPPING_INTERVAL_FAKE_ITEM = 'SNAPPING_INTERVAL_FAKE_ITEM';
